const DESCRIPTOR_RULES = {
  sheet: { unitType: 'piece', packType: 'sheet', multiplier: 1, priority: 2 },
  sheets: { unitType: 'piece', packType: 'sheet', multiplier: 1, priority: 2 },
  pack: { unitType: 'piece', packType: 'pack', multiplier: 1, priority: 1 },
  packs: { unitType: 'piece', packType: 'pack', multiplier: 1, priority: 1 },
  pk: { unitType: 'piece', packType: 'pack', multiplier: 1, priority: 1 },
  pkt: { unitType: 'piece', packType: 'pack', multiplier: 1, priority: 1 },
  piece: { unitType: 'piece', packType: 'piece', multiplier: 1, priority: 1 },
  pieces: { unitType: 'piece', packType: 'piece', multiplier: 1, priority: 1 },
  pc: { unitType: 'piece', packType: 'piece', multiplier: 1, priority: 1 },
  pcs: { unitType: 'piece', packType: 'piece', multiplier: 1, priority: 1 },
  count: { unitType: 'piece', packType: 'count', multiplier: 1, priority: 1 },
  counts: { unitType: 'piece', packType: 'count', multiplier: 1, priority: 1 },
  ct: { unitType: 'piece', packType: 'count', multiplier: 1, priority: 1 },
  wipe: { unitType: 'wipe', packType: 'wipe', multiplier: 1, priority: 2 },
  wipes: { unitType: 'wipe', packType: 'wipe', multiplier: 1, priority: 2 },
  pad: { unitType: 'piece', packType: 'pad', multiplier: 1, priority: 2 },
  pads: { unitType: 'piece', packType: 'pad', multiplier: 1, priority: 2 },
  bud: { unitType: 'piece', packType: 'bud', multiplier: 1, priority: 2 },
  buds: { unitType: 'piece', packType: 'bud', multiplier: 1, priority: 2 },
  roll: { unitType: 'piece', packType: 'roll', multiplier: 1, priority: 2 },
  rolls: { unitType: 'piece', packType: 'roll', multiplier: 1, priority: 2 },
  pair: { unitType: 'piece', packType: 'pair', multiplier: 1, priority: 2 },
  pairs: { unitType: 'piece', packType: 'pair', multiplier: 1, priority: 2 },
  tab: { unitType: 'piece', packType: 'tablet', multiplier: 1, priority: 2 },
  tabs: { unitType: 'piece', packType: 'tablet', multiplier: 1, priority: 2 },
  tablet: { unitType: 'piece', packType: 'tablet', multiplier: 1, priority: 2 },
  tablets: { unitType: 'piece', packType: 'tablet', multiplier: 1, priority: 2 },
  cap: { unitType: 'piece', packType: 'capsule', multiplier: 1, priority: 2 },
  caps: { unitType: 'piece', packType: 'capsule', multiplier: 1, priority: 2 },
  capsule: { unitType: 'piece', packType: 'capsule', multiplier: 1, priority: 2 },
  capsules: { unitType: 'piece', packType: 'capsule', multiplier: 1, priority: 2 },
  ml: { unitType: 'ml', packType: 'ml', multiplier: 1, priority: 3 },
  l: { unitType: 'ml', packType: 'litre', multiplier: 1000, priority: 3 },
  liter: { unitType: 'ml', packType: 'litre', multiplier: 1000, priority: 3 },
  liters: { unitType: 'ml', packType: 'litre', multiplier: 1000, priority: 3 },
  litre: { unitType: 'ml', packType: 'litre', multiplier: 1000, priority: 3 },
  litres: { unitType: 'ml', packType: 'litre', multiplier: 1000, priority: 3 },
  g: { unitType: 'g', packType: 'g', multiplier: 1, priority: 3 },
  gram: { unitType: 'g', packType: 'g', multiplier: 1, priority: 3 },
  grams: { unitType: 'g', packType: 'g', multiplier: 1, priority: 3 },
  kg: { unitType: 'g', packType: 'kg', multiplier: 1000, priority: 3 },
  kilogram: { unitType: 'g', packType: 'kg', multiplier: 1000, priority: 3 },
  kilograms: { unitType: 'g', packType: 'kg', multiplier: 1000, priority: 3 }
};

const DESCRIPTOR_PATTERN = Object.keys(DESCRIPTOR_RULES)
  .sort((a, b) => b.length - a.length)
  .join('|');
const VALUE_PATTERN = '\\d+(?:[.,]\\d+)?';

const NUMBER_THEN_DESCRIPTOR_REGEX = new RegExp(
  `(${VALUE_PATTERN})\\s*(${DESCRIPTOR_PATTERN})\\b`,
  'gi'
);

const DESCRIPTOR_THEN_NUMBER_REGEX = new RegExp(
  `\\b(${DESCRIPTOR_PATTERN})\\s*(?:of\\s+)?(${VALUE_PATTERN})\\b`,
  'gi'
);

const MULTIPLIER_REGEX = new RegExp(
  `(${VALUE_PATTERN})\\s*[xX\\u00D7]\\s*(${VALUE_PATTERN})\\s*(${DESCRIPTOR_PATTERN})\\b`,
  'gi'
);

const parseNumeric = (value) => {
  if (value === null || value === undefined) return null;
  const raw = String(value).trim();
  if (!raw) return null;

  const cleaned = raw.replace(/[^\d.,-]/g, '');
  if (!cleaned) return null;

  let normalized = cleaned;
  const hasComma = cleaned.includes(',');
  const hasDot = cleaned.includes('.');

  if (hasComma && hasDot) {
    normalized = cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')
      ? cleaned.replace(/\./g, '').replace(/,/g, '.')
      : cleaned.replace(/,/g, '');
  } else if (hasComma && !hasDot) {
    normalized = cleaned.replace(/,/g, '.');
  }

  const parsed = parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};

const normalizeUnits = (value) => {
  if (!Number.isFinite(value) || value <= 0) return null;
  const rounded = Math.round(value);
  if (Math.abs(value - rounded) < 0.0001) return rounded;
  return parseFloat(value.toFixed(3));
};

const normalizeDescriptorKey = (value = '') => String(value).toLowerCase().replace(/[^a-z]/g, '');

const getCandidateScore = (rule, isMultiplierMatch) => {
  const base = Number(rule?.priority) || 0;
  return isMultiplierMatch ? base + 1 : base;
};

const pickBestCandidate = (candidates = []) => {
  if (!Array.isArray(candidates) || candidates.length === 0) return null;

  const sorted = [...candidates].sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    if (b.end !== a.end) return b.end - a.end;
    if (b.start !== a.start) return b.start - a.start;
    return (b.matchedText?.length || 0) - (a.matchedText?.length || 0);
  });

  return sorted[0] || null;
};

const removeMatchedSegment = (description = '', candidate = null) => {
  if (!candidate) return description;
  const before = description.slice(0, candidate.start);
  const after = description.slice(candidate.end);
  return `${before} ${after}`
    .replace(/\s+/g, ' ')
    .replace(/\s+([,.;:])/g, '$1')
    .replace(/[-,:;]\s*$/, '')
    .trim();
};

export const parseLineItemPackDetails = (rawDescription = '') => {
  const description = String(rawDescription || '').replace(/\s+/g, ' ').trim();
  if (!description) {
    return {
      unitsPerPack: null,
      unitType: '',
      packType: '',
      baseDescription: ''
    };
  }

  const candidates = [];

  const registerCandidate = (match, rawUnits, rawDescriptor, isMultiplierMatch = false, multiplierValue = 1) => {
    const descriptorKey = normalizeDescriptorKey(rawDescriptor);
    const descriptorRule = DESCRIPTOR_RULES[descriptorKey];
    if (!descriptorRule) return;

    const unitsValue = parseNumeric(rawUnits);
    const multiplier = Number.isFinite(multiplierValue) && multiplierValue > 0 ? multiplierValue : 1;
    if (!Number.isFinite(unitsValue) || unitsValue <= 0) return;

    const normalizedUnits = normalizeUnits(unitsValue * multiplier * descriptorRule.multiplier);
    if (!Number.isFinite(normalizedUnits) || normalizedUnits <= 0) return;

    candidates.push({
      start: match.index,
      end: match.index + match[0].length,
      unitsPerPack: normalizedUnits,
      unitType: descriptorRule.unitType,
      packType: descriptorRule.packType,
      score: getCandidateScore(descriptorRule, isMultiplierMatch),
      matchedText: match[0]
    });
  };

  for (const match of description.matchAll(MULTIPLIER_REGEX)) {
    const multiplier = parseNumeric(match[1]);
    registerCandidate(match, match[2], match[3], true, multiplier || 1);
  }

  for (const match of description.matchAll(NUMBER_THEN_DESCRIPTOR_REGEX)) {
    registerCandidate(match, match[1], match[2], false, 1);
  }

  for (const match of description.matchAll(DESCRIPTOR_THEN_NUMBER_REGEX)) {
    registerCandidate(match, match[2], match[1], false, 1);
  }

  const bestCandidate = pickBestCandidate(candidates);
  if (!bestCandidate) {
    return {
      unitsPerPack: null,
      unitType: '',
      packType: '',
      baseDescription: description
    };
  }

  const cleanedDescription = removeMatchedSegment(description, bestCandidate);

  return {
    unitsPerPack: bestCandidate.unitsPerPack,
    unitType: bestCandidate.unitType,
    packType: bestCandidate.packType,
    baseDescription: cleanedDescription || description
  };
};
